import { useState } from 'react';
import { useMutation } from '@apollo/client';

import useToast from '../../../../customHooks/useToast';
import { APPROVE_GUARANTEE, APPROVE_PRE_APPROVAL_RENT_GUARANTEE } from '../../../../graphql/admin_mutations';
import AdminModal from '../../../../components/AdminModal';

import InfoIconNew from '../../../../svgs/InfoIconNew';

interface IApproveGuaranteeModal {
  closeModal?: any;
  guaranteeId?: string;
  refetch?:any;
  title: string;
  subTitle: string;
  type?: string;
  guaranteeType?: string
  isShow?: boolean;
  setModalDetail?: any;
}

const ApproveGuaranteeModal = ({
  closeModal, guaranteeId, refetch, title, subTitle, type, guaranteeType, isShow, setModalDetail,
}: IApproveGuaranteeModal) => {
  const [
    showApproveGuaranteeSuccessfulModal,
    setShowApproveGuaranteeSuccessfulModal,
  ] = useState(false);
  const Toast = useToast();
  const [approveRentGuarantee, { loading: approveGuaranteeLoading }] = useMutation<
  { approveRentGuarantee: any },
  any
>(APPROVE_GUARANTEE);

  const [
    approvePreApprovalRentGuarantee,
    { loading: approvePreApprovalRentGuaranteeLoading },
  ] = useMutation<
  { approvePreApprovalRentGuarantee: any },
  any
>(APPROVE_PRE_APPROVAL_RENT_GUARANTEE);

  const isLoading = guaranteeType === 'pre-approval' ? approvePreApprovalRentGuaranteeLoading : approveGuaranteeLoading;

  const handleApproval = async (mutation, variables) => {
    try {
      const res = await mutation({ variables });
      handleOperationResult(res);
    } catch (error) {
      handleOperationError(error);
    }
  };

  const handleOperationResult = (res) => {
    const operation = guaranteeType === 'pre-approval' ? 'approvePreApprovalRentGuarantee' : 'approveRentGuarantee';
    const operationData = res?.data?.[operation];

    if (operationData && operationData?.status === 200) {
      Toast.success(operationData?.message || 'Operation successful');
      setModalDetail({
        title: `${type === 'approve' ? 'Approved' : 'Declined'} Successfully!`,
        subTitle: `You have successfully ${type === 'approve' ? 'approved' : 'declined'} this guarantee and it will be reflected on your dashboard.`,
      });
      setShowApproveGuaranteeSuccessfulModal(true);
      refetch?.();
    } else {
      Toast.error(operationData?.message || 'Operation Failed');
    }
  };

  const handleOperationError = (error) => {
    if (error && error?.graphQLErrors && error?.graphQLErrors.length > 0) {
      Toast.error(error?.graphQLErrors[0]?.message);
    } else {
      Toast.error('Something went wrong');
    }
  };

  const handleConfirmClick = async () => {
    if (!isLoading) {
      const variables = {
        id: guaranteeId,
        shouldApprove: type === 'approve',
      };
      const mutation = guaranteeType === 'pre-approval' ? approvePreApprovalRentGuarantee : approveRentGuarantee;
      await handleApproval(mutation, variables);
    }
  };

  return (
    <AdminModal
      headText={title}
      subText={isLoading ? 'Processing...' : subTitle}
      actionBtnName="confirm"
      handleModalAction={handleConfirmClick}
      topIcon={<InfoIconNew />}
      isShow={isShow}
      isSuccess={showApproveGuaranteeSuccessfulModal}
      onClickAway={closeModal}
      onClose={closeModal}
      isLoading={isLoading}
    />
  );
};

export default ApproveGuaranteeModal;
